import { Question } from '../global'

// A technique selection question is shown inside the technique card: either the price simulation input or the VME confirmation.
export function isSimulationInput({ type, answerType }: Question): boolean {
    return type === 'technique_selection' && answerType === 'numeric'
}

export function isVmeConfirmation({ type, answerType }: Question): boolean {
    return type === 'technique_selection' && answerType === 'select'
}
